import styled from 'styled-components';

import { ReactComponent as Success } from 'images/Success.svg';
import { ReactComponent as Warning } from 'images/Warning.svg';
import { ReactComponent as ErrorSVG } from 'images/Error.svg';
import { common } from 'themes/default';
import variants from './AlertBox.variants';

const getColours = (variant) => {
  switch (variant) {
    case variants.SUCCESS:
      return common.notifications.success;
    case variants.WARNING:
      return common.notifications.alert;
    case variants.ERROR:
      return common.notifications.error;
    case variants.INFO:
    default:
      return common.notifications.information;
  }
};

export const Pill = styled.div`
  background: ${(props) => getColours(props.variant).backgroundColour};
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => getColours(props.variant).borderColour};
  color: ${(props) => getColours(props.variant).fontColour};
  padding: 8px 16px;
  display: flex;
  align-items: center;
`;

export const Contents = styled.div`
  display: block;
  padding-left: 8px;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const iconStyles = 'margin: auto 0;';

export const WarningIcon = styled(Warning)`
  ${iconStyles}
`;

export const SuccessIcon = styled(Success)`
  ${iconStyles}
`;

export const ErrorIcon = styled(ErrorSVG)`
  ${iconStyles}
`;
